import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';

import { Input } from '@material-tailwind/react';

import { v4 as uuidv4 } from 'uuid';
import { mintCheck } from '../util/api';
import { useNavigate } from 'react-router-dom';
import data from '../assets/metadata.json';
import skeletonImg from '../assets/imgs/skeleton.webp';
import logo from '../assets/imgs/logo.webp';
import xLogo from '../assets/imgs/x.png';

export default function Home({ isMaintenance }) {
  if (isMaintenance) {
    navigate('/maintenance');
  }

  const navigate = useNavigate();

  return (
    <div className='flex sm:flex-row flex-col sm:gap-8 gap-4 mt-[20px] md:mt-[100px] z-[9999]'>
      <div className='md:flex hidden flex-row gap-10 p-[100px] items-center'>
        <img
          src={skeletonImg}
          className='w-[400px] h-[400px] border-solid border-red-800 border-[3px] rounded-md'
        />
        <div className='flex flex-col gap-2 w-full max-w-[600px]'>
          <div className='text-white text-3xl font-bold'>
            “THE <span className='text-red-800'>EYES</span> ARE ALWAYS WATCHING”
          </div>
          <div className='text-white text-2xl'>
            A 21,000-piece Bitcoin Ordinal collection created by Mr. Black, a
            pseudonymous artist inspired by the divine to last an eternity. The
            collection, “The Eyes Are Always Watching,” emphasizes “Fear God,
            not man” revealing secrets that could change humanity and usher in
            the Messianic Age.
          </div>
          <div className='flex flex-row gap-2 justify-end'>
            <a href='https://twitter.com/mrblack4384' target='_blank'>
              <img
                src={xLogo}
                alt='Twitter'
                className='cursor-pointer w-[30px]'
              />
            </a>
          </div>
        </div>
      </div>
      <div className='md:hidden flex flex-col gap-5 items-center px-2 w-full justify-center'>
        <img src={logo} className='h-[60px]' onClick={() => navigate('/')} />
        <img
          src={skeletonImg}
          className='w-[300px] h-[300px] border-solid border-red-800 border-[3px] rounded-md'
        />
        <div className='text-white text-xl font-bold text-center'>
          “THE <span className='text-red-800'>EYES</span> ARE ALWAYS WATCHING”
        </div>
        <div className='text-white text-md px-2 text-center'>
          A 21,000-piece Bitcoin Ordinal collection created by Mr. Black, a
          pseudonymous artist inspired by the divine to last an eternity. The
          collection, “The Eyes Are Always Watching,” emphasizes “Fear God, not
          man” revealing secrets that could change humanity and usher in the
          Messianic Age.
        </div>
        <div className='flex flex-row gap-2 justify-center w-full px-2 text-center'>
          <a href='https://twitter.com/mrblack4384' target='_blank'>
            <img
              src={xLogo}
              alt='Twitter'
              className='cursor-pointer w-[30px]'
            />
          </a>
        </div>
      </div>
    </div>
  );
}
